<template>
  <tr v-if="value >= threshold" class="px-3 font-size-m">
    <th
      class="nutrient-row-th font-weight-bold pa-3 font-size-s text-uppercase"
      scope="row"
    >
      {{ name }}
    </th>
    <td style="width: 65%" class="pa-3 text-center">
      {{ float(value) + ' ' + unit }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'NutrientRow',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    unit: {
      type: String,
      required: true
    },
    threshold: {
      type: Number,
      required: true
    }
  }
}
</script>

<style>
.nutrient-row-th {
  width: 35%;
  color: rgb(var(--v-theme-gray));
  line-height: 1;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-align: left;
  padding: 8px;
  box-sizing: border-box;
}
</style>
